<div class="container" [formGroup]="form" [ngStyle]="{ justifyContent: displayFieldSelection ? '' : 'start' }">
  <div class="container__prefix">
    <ng-content select="[prefix]" />
  </div>
  @if (displayFieldSelection) {
    <div class="container__field">
      <ts-select
        [items]="fields"
        itemKey="name"
        itemLabel="label"
        [hasGroups]="hasGroups"
        data-testid="field-name"
        formControlName="fieldName"
        [uiOptions]="{
          roundedBorders: false,
          placeholder: 'field name',
          searchPlaceholder: 'Field name...',
          size: 'medium',
        }"
      >
      </ts-select>
    </div>
  }
  <div class="container__operator">
    <ts-select
      [items]="
        (filterValue?.fieldName | tsFieldFromName: fields)?.meta.filtering.operators
          | tsMutateToAny: mutateOperatorListFn
      "
      itemKey="name"
      itemLabel="label"
      formControlName="operator"
      [disabled]="!filterValue?.fieldName"
      [uiOptions]="{
        roundedBorders: false,
        placeholder: 'operation',
        searchPlaceholder: 'Operation...',
        size: 'small',
        disabledClass: 'disabled-transparent',
      }"
    >
    </ts-select>
  </div>
  <div class="container__value">
    <ng-container *ngIf="filterValue?.fieldName | tsFieldFromName: fields as field; else placeholderField">
      <ng-template #emptySelectTemplate>
        <ts-select
          [items]="getEmptyOptions()"
          itemKey="value"
          itemLabel="label"
          [useMousedownSelection]="true"
          formControlName="value"
          [uiOptions]="{
            roundedBorders: false,
            placeholder: 'value',
            searchPlaceholder: 'Select option...',
            size: 'medium',
          }"
        >
        </ts-select>
      </ng-template>

      <ng-container [ngSwitch]="field?.type">
        <ng-container *ngSwitchCase="'select'">
          <ng-container *ngIf="operator.value === 'is'; else defaultSelectFilter">
            <ng-container *ngTemplateOutlet="emptySelectTemplate"></ng-container>
          </ng-container>
          <ng-template #defaultSelectFilter>
            <mat-form-field TsFieldStyling [fieldBackgroundColor]="valueBackgroundColor" [fieldBold]="isValueBold">
              <mat-select
                #select
                formControlName="value"
                multiple
                (closed)="onValueSelectBlur(select)"
                placeholder="value"
                data-testid="value-select"
              >
                <ng-container *ngFor="let item of field?.meta.options | tsFilterBy: [] : field?.meta : innerFilterFn">
                  <mat-option *ngIf="item | TsIsObject; else itemIsString" [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                  <ng-template #itemIsString>
                    <mat-option [value]="item">{{ item }}</mat-option>
                  </ng-template>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'checkbox'">
          <mat-form-field TsFieldStyling [fieldBackgroundColor]="valueBackgroundColor" [fieldBold]="isValueBold">
            <mat-select
              #selectCheckbox
              formControlName="value"
              multiple
              (closed)="onValueSelectBlur(selectCheckbox)"
              placeholder="value"
            >
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <ng-container *ngSwitchCase="'decimal'">
          <ng-container *ngIf="operator.value === 'is'; else defaultDecimalFilter">
            <ng-container *ngTemplateOutlet="emptySelectTemplate"></ng-container>
          </ng-container>
          <ng-template #defaultDecimalFilter>
            <mat-form-field
              TsFieldStyling
              [fieldBackgroundColor]="valueBackgroundColor"
              [fieldBold]="isValueBold"
              appearance="fill"
            >
              <input
                matInput
                type="text"
                formControlName="value"
                placeholder="value"
                [mask]="getMaskForNumberDecimal(field)"
                (blur)="onValueInputBlur($event)"
              />
            </mat-form-field>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'number'">
          <ng-container *ngIf="operator.value === 'is'; else defaultNumberFilter">
            <ng-container *ngTemplateOutlet="emptySelectTemplate"></ng-container>
          </ng-container>
          <ng-template #defaultNumberFilter>
            <mat-form-field
              TsFieldStyling
              [fieldBackgroundColor]="valueBackgroundColor"
              [fieldBold]="isValueBold"
              appearance="fill"
            >
              @if (field.name === 'id' || field.name.endsWith('.id')) {
                <input
                  matInput
                  type="text"
                  formControlName="value"
                  placeholder="value"
                  (blur)="onValueInputBlur($event)"
                />
              } @else {
                <input
                  matInput
                  type="text"
                  formControlName="value"
                  placeholder="value"
                  [mask]="getMaskForNumberDecimal(field)"
                  (blur)="onValueInputBlur($event)"
                />
              }
            </mat-form-field>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'money'">
          <ng-container *ngIf="operator.value === 'is'; else defaultMoneyFilter">
            <ng-container *ngTemplateOutlet="emptySelectTemplate"></ng-container>
          </ng-container>
          <ng-template #defaultMoneyFilter>
            <mat-form-field
              TsFieldStyling
              [fieldBackgroundColor]="valueBackgroundColor"
              [fieldBold]="isValueBold"
              appearance="fill"
            >
              <input
                matInput
                currencyMask
                formControlName="value"
                placeholder="value"
                [options]="{ align: 'left', precision: field.meta?.scale || 0, prefix: '$' }"
                (blur)="onValueInputBlur($event)"
              />
            </mat-form-field>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'percent'">
          <ng-container *ngIf="operator.value === 'is'; else defaultPercentFilter">
            <ng-container *ngTemplateOutlet="emptySelectTemplate"></ng-container>
          </ng-container>
          <ng-template #defaultPercentFilter>
            <mat-form-field
              TsFieldStyling
              [fieldBackgroundColor]="valueBackgroundColor"
              [fieldBold]="isValueBold"
              appearance="fill"
            >
              <input
                matInput
                type="text"
                mask="separator.2"
                decimalMarker="."
                thousandSeparator=","
                formControlName="value"
                placeholder="value"
                [allowNegativeNumbers]="true"
                (blur)="onValueInputBlur($event)"
              />
            </mat-form-field>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'datetime'">
          <ts-select
            *ngIf="operator.value === 'is'; else defaultDateFilter"
            [items]="
              getDateOptionsWithEmpty((filterValue?.fieldName | tsFieldFromName: fields)?.meta.filtering.functions)
            "
            itemKey="value"
            itemLabel="label"
            [useMousedownSelection]="true"
            formControlName="value"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'value',
              searchPlaceholder: 'Search date functions...',
              size: 'medium',
            }"
          >
          </ts-select>
          <ng-template #defaultDateFilter>
            <mat-form-field
              TsFieldStyling
              [fieldBackgroundColor]="valueBackgroundColor"
              [fieldBold]="isValueBold"
              [maxElementColoringRecursionDepth]="3"
              class="datetime"
              appearance="fill"
            >
              <input
                matInput
                readonly
                [matDatepicker]="datePicker"
                formControlName="value"
                placeholder="value"
                (dateChange)="onValueDateBlur($event)"
                (click)="datePicker.open()"
              />
              <mat-datepicker #datePicker></mat-datepicker>
              <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
              <mat-error> Date should be in MM/DD/YYYY format.</mat-error>
            </mat-form-field>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'date'">
          <ts-select
            *ngIf="operator.value === 'is'; else defaultDateFilter"
            [items]="
              getDateOptionsWithEmpty((filterValue?.fieldName | tsFieldFromName: fields)?.meta.filtering.functions)
            "
            itemKey="value"
            itemLabel="label"
            [useMousedownSelection]="true"
            formControlName="value"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'value',
              searchPlaceholder: 'Search date functions...',
              size: 'medium',
            }"
          >
          </ts-select>
          <ng-template #defaultDateFilter>
            <mat-form-field
              TsFieldStyling
              [fieldBackgroundColor]="valueBackgroundColor"
              [fieldBold]="isValueBold"
              [maxElementColoringRecursionDepth]="3"
              class="datetime"
              appearance="fill"
            >
              <input
                matInput
                readonly
                [matDatepicker]="datePicker"
                formControlName="value"
                placeholder="value"
                (dateChange)="onValueDateBlur($event)"
                (click)="datePicker.open()"
              />
              <mat-datepicker #datePicker></mat-datepicker>
              <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
              <mat-error> Date should be in MM/DD/YYYY format.</mat-error>
            </mat-form-field>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'record'">
          <ng-container *ngIf="operator.value === 'is'; else defaultRecordFilter">
            <ng-container *ngTemplateOutlet="emptySelectTemplate"></ng-container>
          </ng-container>
          <ng-template #defaultRecordFilter>
            <mat-form-field TsFieldStyling [fieldBackgroundColor]="valueBackgroundColor" [fieldBold]="isValueBold">
              <mat-select
                #recordSelect
                formControlName="value"
                multiple
                (closed)="onValueSelectBlur(recordSelect)"
                (opened)="onValueSelectOpen(recordSelect)"
                (selectionChange)="onValueSelectChange($event)"
                placeholder="value"
              >
                <mat-form-field class="sticky top-0 z-10 w-full p-2 pb-0">
                  <input matInput placeholder="Search..." autocomplete="off" [formControl]="recordSearch" />
                </mat-form-field>
                <mat-option *ngIf="lookupLoading | async; else placeholderOption" class="no-checkbox" disabled>
                  <mat-progress-spinner class="spinner" diameter="24" mode="indeterminate"> </mat-progress-spinner>
                </mat-option>
                <ng-template #placeholderOption>
                  <mat-option class="no-checkbox h-0" disabled> </mat-option>
                </ng-template>
                <mat-option *ngFor="let result of selectedLookupResults" [value]="result.id">{{
                  result.label
                }}</mat-option>
                <mat-option
                  *ngFor="let result of lookupResults | async | tsFilterBy: [] : selectedLookupResults : hideSelected"
                  [value]="result.id"
                  >{{ result.label }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngIf="operator.value === 'is'; else defaultInputFilter">
            <ng-container *ngTemplateOutlet="emptySelectTemplate"></ng-container>
          </ng-container>
          <ng-template #defaultInputFilter>
            <mat-form-field
              TsFieldStyling
              [fieldBackgroundColor]="valueBackgroundColor"
              [fieldBold]="isValueBold"
              appearance="fill"
            >
              <input matInput formControlName="value" (blur)="onValueInputBlur($event)" placeholder="value" />
            </mat-form-field>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #placeholderField>
      <mat-form-field appearance="fill">
        <input matInput disabled placeholder="value" />
      </mat-form-field>
    </ng-template>
  </div>
  <ng-content select="[additional-actions]" />

  <div class="container__suffix">
    <ts-button type="icon" icon="ts_trash-alt" iconColor="black" (click)="filterRemoved.emit(index)"></ts-button>
  </div>
</div>
